export enum TimePeriod {
  LAST7DAYS = 'last7days',
  LAST30DAYS = 'last30days',
  LAST90DAYS = 'last90days',
  LAST365DAYS = 'last365days',
  CUSTOM = 'custom',
}
